import i18n from '../i18n';

// Язык генерируемых документов (отчёты, акты, сметы, ведомости).
// Порядок: явный выбор → язык коммуникаций Контакта → язык интерфейса.
// При английском интерфейсе фоллбэк — английский, при русском — прежний 'ru'.
// Зеркало backend/utils/docLang.js: правила держать одинаковыми.

/** Язык интерфейса как язык документа: 'en' | 'ru'. */
export const uiDocLang = () => (String(i18n.language || 'ru').startsWith('en') ? 'en' : 'ru');

/** Язык Контакта, если задан ('ru' | 'en'), иначе язык интерфейса. */
export const pickDocLang = (contactLang) => (contactLang === 'ru' || contactLang === 'en' ? contactLang : uiDocLang());
